<template>
  <div>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loading"
    >
      <b-card>
        <b-form
          @submit.prevent="fetchDrivers"
        >
          <b-row class="mb-1">
            <b-col md="6">
              <b-input-group prepend="+">
                <b-form-input
                  v-model="searchQuery.phone_number"
                  placeholder="Search by phone number"
                />
              </b-input-group>
            </b-col>
            <b-col md="6">
              <b-button
                type="submit"
                variant="primary"
              >
                Search
              </b-button>
            </b-col>
          </b-row>
        </b-form>
        <b-table
          :items="drivers"
          :fields="tableColumns"
          show-empty
          empty-text="No matching drivers found"
          :per-page="perPage"
          :current-page="page"
        >
          <template #cell(UserCreateDate)="data">
            {{ data.item.UserCreateDate | formatDate }}
          </template>
          <template #cell(actions)="data">
            <b-dropdown
              v-if="$can('write', 'drivers')"
              variant="link"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="reSendCode(data.item)">
                <feather-icon icon="RefreshCcwIcon" />
                <span class="align-middle ml-50">Resend Code</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <base-pagination
          v-model="page"
          :total="total"
          @new-per-page="perPage = $event"
        />
      </b-card>

    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay, BTable, BCard, BDropdown, BDropdownItem, BForm, BFormInput, BButton, BInputGroup, BRow, BCol,
} from 'bootstrap-vue'
import { ref, reactive } from '@vue/composition-api'
import useRegistoreStoreModule from '@/hooks/useRegisterStoreModule'
import store from '../driverStoreModule'
import BasePagination from '@/UI/BasePagination.vue'

export default {
  components: {
    BOverlay,
    BCard,
    BTable,
    BDropdown,
    BDropdownItem,
    BasePagination,
    BForm,
    BFormInput,
    BButton,
    BInputGroup,
    BRow,
    BCol,
  },
  setup(_, ctx) {
    useRegistoreStoreModule('drivers', store)
    const loading = ref(false)
    const drivers = ref([])
    const searchQuery = reactive({
      phone_number: null,
    })
    const tableColumns = [
      {
        label: 'Phone Number',
        key: 'Attributes',
        formatter: attrs => attrs.find(attr => attr.Name === 'phone_number').Value,
      },
      {
        label: 'Created At',
        key: 'UserCreateDate',
      },
      'actions',
    ]
    const total = ref()
    const page = ref(1)
    const perPage = ref(10)
    const fetchDrivers = async () => {
      try {
        loading.value = true
        const res = await ctx.root.$store.dispatch('drivers/fetchUnverifiedDrivers', searchQuery)
        const { Users } = res.data.data
        total.value = Users.length
        drivers.value = Users
      } finally {
        loading.value = false
      }
    }
    const reSendCode = async evt => {
      try {
        const phone = evt.Attributes.find(attr => attr.Name === 'phone_number').Value
        await ctx.root.$store.dispatch('drivers/resendConfirmationCode', phone)
        ctx.root.$router.push({
          name: 'drivers-new',
          query: {
            phone,
          },
        })
      } catch (error) {
        console.log(error)
      }
    }
    fetchDrivers()

    return {
      loading,
      tableColumns,
      drivers,
      reSendCode,
      fetchDrivers,
      total,
      page,
      perPage,
      searchQuery,
    }
  },
}
</script>

<style>

</style>
